import tpl from './person-info.tpl.html';
import './person-info.scss';

/**
 * A small info component that displays a person's image and name.
 */
class PersonInfoComponent {
  constructor() {
    'ngInject';

    /**
     * Person given by the parent component.
     * @type {Person}
     */
    this.person = null;

    /**
     * Show "full info", that is name heading + title. If not, only show name as smaller text.
     * @type {boolean}
     */
    this.fullInfo = false;

    /**
     * Location given by the parent component.
     * @type {Location}
     */
    this.location = null;
  }
}

const config = {
  templateUrl: tpl,
  controller: PersonInfoComponent,
  bindings: {
    person: '<',
    fullInfo: '<?',
    location: '<?'
  }
};

const mod = angular.module('app.common.components.personInfo', [])

.component('personInfo', config);

export default mod.name;
